import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\InvoiceExport\GetAccountingDiariesListForExportController::__invoke
* @see app/Http/Controllers/InvoiceExport/GetAccountingDiariesListForExportController.php
* @route '/api/invoice/export/account-diary'
*/
const GetAccountingDiariesListForExportController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAccountingDiariesListForExportController.url(options),
    method: 'get',
})

GetAccountingDiariesListForExportController.definition = {
    methods: ["get","head"],
    url: '/api/invoice/export/account-diary',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\InvoiceExport\GetAccountingDiariesListForExportController::__invoke
* @see app/Http/Controllers/InvoiceExport/GetAccountingDiariesListForExportController.php
* @route '/api/invoice/export/account-diary'
*/
GetAccountingDiariesListForExportController.url = (options?: RouteQueryOptions) => {
    return GetAccountingDiariesListForExportController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\InvoiceExport\GetAccountingDiariesListForExportController::__invoke
* @see app/Http/Controllers/InvoiceExport/GetAccountingDiariesListForExportController.php
* @route '/api/invoice/export/account-diary'
*/
GetAccountingDiariesListForExportController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAccountingDiariesListForExportController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\InvoiceExport\GetAccountingDiariesListForExportController::__invoke
* @see app/Http/Controllers/InvoiceExport/GetAccountingDiariesListForExportController.php
* @route '/api/invoice/export/account-diary'
*/
GetAccountingDiariesListForExportController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetAccountingDiariesListForExportController.url(options),
    method: 'head',
})

export default GetAccountingDiariesListForExportController